export default __webpack_public_path__ + "static/media/social-linkedin.a27c5ef7.svg";